module.exports = __webpack_public_path__ + "static/media/inner-circle.511b5776.svg";